import type { OpenAPI } from "simplydo/interfaces";

export type CalendarQueryData =
  OpenAPI.GET<"/calendars/{calendar_id}/calendar">["response"];

export type CalendarType = NonNullable<CalendarQueryData["calendar"]>;
export type CalendarResponseEvent = NonNullable<CalendarType["events"]>[number];

/** Runtime fields not always present on generated calendar event types. */
export type ChallengeCalendarEvent = CalendarResponseEvent & { plan?: string };

export type CalendarEventMember = {
  _id?: string;
  profile?: {
    fullName?: string;
    firstName?: string;
    lastName?: string;
    jobTitle?: string;
    department?: string;
  };
};

export type CalendarWithDates = Omit<CalendarType, "start" | "end"> & {
  start: Date;
  end: Date;
};

export type CalendarEventWithDates = Omit<
  CalendarResponseEvent,
  "from" | "to" | "type" | "ownerMembers"
> & {
  from: Date;
  to?: Date;
  type?: CalendarResponseEvent["type"] | "meeting" | "reminder";
  ownerMembers?: CalendarEventMember[];
  organiserName?: string;
  organiserEmail?: string;
};

export type CalendarEditingEvent = Partial<
  CalendarEventWithDates & {
    eventContent?: OpenAPI.Schemas["Announcement"];
    plan?: string;
  }
>;

export type CreateCalendarEventBody = Omit<
  OpenAPI.POST<"/calendars/{calendar_id}/calendar/events">["requestBody"],
  "notifications"
> & { notifications?: NonNullable<CalendarResponseEvent["notifications"]> };

export type CellAction = {
  name: string;
  onlyVisibleInRange?: boolean;
  action: (dayDate: string) => CalendarResponseEvent;
};

export const isEditableCalendarEventType = (type?: string) =>
  type === "event" || type === "meeting" || type === "reminder";
